









































































import { Component, Vue } from "vue-property-decorator";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import {
  MessageType,
  UserSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
@Component({
  name: "description-booth-modal-component",
})
export default class ExitModalComponent extends Vue {
  loading;
  count = 3;
  timerCountdown;
  mounted() {
    this.$store.dispatch("SpaceStore/getRoomAction", {
      roomId: this.roomDescriptionId,
      callback: () => {},
    });
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getDescriptionBoothModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setDescriptionBoothModalAction", e);
  }
  get roomDescriptionId(): number {
    return this.$store.getters["SystemStore/getDescriptionBoothModalData"];
  }
  get room(): RoomInterface | null {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (space) {
      return space.scenario.rooms.filter(
        (a) => a.id === this.roomDescriptionId
      )[0];
    }
    return null;
  }
  /*get activeCountDown(): boolean {
    const activate =
      this.$store.getters["SystemStore/getDescriptionBoothCountDown"];
    if (activate) this.countdown();
    else {
      clearTimeout(this.timerCountdown);
      this.count = 3;
    }
    return activate;
  }*/
  /*countdown(): void {
    this.timerCountdown = setTimeout(() => {
      this.count--;
      if (this.count >= 0) this.countdown();
      else {
        this.$store.dispatch(
          "SystemStore/setDescriptionBoothCountDownModalAction",
          false
        );
      }
    }, 1000);
  }*/
  openWeb(): void {
    if (this.room.wonderPoint.openUrlExternally) {
      window.open(this.room.wonderPoint.url, "_blank").focus();
    } else {
      this.$store.dispatch(
        "SystemStore/setWonderPointUrlAction",
        this.room.wonderPoint.url
      );
      this.$store.dispatch("SystemStore/setOpenWonderPointModalAction", true);
      this.active = false;
    }
  }
  goToRoom(): void {
    this.active = false;
    GraphicClient.sendMessage(
      MessageType.USER,
      UserSendMessageType.MOVE_LOCAL_USER,
      {
        graphicClientRoomId: this.room.graphicClientRoomId,
        id: this.room.id
      }
    );
  }
}
